import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a7ca949"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { computed, onMounted, Ref, ref, watchEffect } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import cmsService from "../../services/cms/cms";
import {
  CmsCustomStrengthMapping,
  CmsDocumentTypes,
} from "../../services/cms/cms-type-definitions";
import CmsService from "../../services/cms/cms-service";
import { StrengthsMappingModel } from "./strengths-mapping.vue";

// @Component
// export default class StrengthsMappingPreCheck extends Vue {

export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-mapping-pre-check',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props;

// @Prop()
//   private model!: StrengthsMappingModel;

const cms: CmsService = cmsService;
const doc: Ref<CmsCustomStrengthMapping | null> = ref(null);
const ready = ref(false);
const isSaving = ref(false);

const begin = () => {
  ready.value = true;
};

const route = useRoute();

const uid: string | undefined = route?.params?.uid as string;
const type: string | undefined = route?.meta?.type as string;

let docPromise: Promise<CmsCustomStrengthMapping> | null = null;

if (uid && type === CmsDocumentTypes.CmsCustomStrengthMapping) {
  docPromise = cms.getByUid(CmsDocumentTypes.CmsCustomStrengthMapping, uid);
} else if (props.model.CmsCustomStrengthMappingId) {
  docPromise = cms.getById(
    CmsDocumentTypes.CmsCustomStrengthMapping,
    props.model.CmsCustomStrengthMappingId,
  );
} else {
  window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
}

if (docPromise) {
  docPromise.then((document) => {
    doc.value = document;
    const questionText = cms.asText(doc.value?.data?.viewpoints_respondent_question);
    if (questionText) {
      begin();
    } else {
      window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
    }
  });
}

function submitChoice(choice: boolean): Promise<void> {
  if (!props.model?.Id) return Promise.reject(new Error("No model/ID supplied"));

  isSaving.value = true;
  return axios
    .post(`/Review/PreCheck/${props.model.Id}`, {
      customStrengthMappingId: props.model.CmsCustomStrengthMappingId,
      customStrengthMappingAnswer: choice,
    })
    .then((e) => {
      window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
    })
    .catch((e) => {
      window.location.reload();
      isSaving.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  return (ready.value && doc.value && doc.value.data)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass({ saving: isSaving.value })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", {
            class: "",
            innerHTML: _unref(cms).asHtml(doc.value.data.viewpoints_respondent_question)
          }, null, 8, _hoisted_2),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-lg btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (submitChoice(true))),
              disabled: isSaving.value
            }, " Yes ", 8, _hoisted_3),
            _createTextVNode("   "),
            _createElementVNode("button", {
              class: "btn btn-lg btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (submitChoice(false))),
              disabled: isSaving.value
            }, " No ", 8, _hoisted_4)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})